import { PageHeader } from "@/components/design";
import { formatCurrency, formatHours } from "@/features/dashboard/utils";
import { useDemo } from "../demo-context";

export function DemoReportsPage() {
  const { state } = useDemo();
  const rows = state.payrollReport;

  return (
    <div className="space-y-6">
      <PageHeader
        title="Reports"
        description="Payroll summary export preview — Jun 16 – Jun 29 pay period"
      />

      <div className="flex flex-wrap gap-2">
        {[
          "Payroll Summary",
          "Site Cost",
          "Worker Hours",
          "Equipment Usage",
          "Overtime",
          "Exceptions",
        ].map((tab, index) => (
          <span
            key={tab}
            className={`rounded-md px-3 py-1.5 text-sm font-medium ${
              index === 0
                ? "bg-navy-deep text-white"
                : "bg-bg-light text-muted-foreground"
            }`}
          >
            {tab}
          </span>
        ))}
      </div>

      <div className="overflow-x-auto rounded-xl border bg-card-white shadow-[var(--shadow-card)]">
        <table className="w-full min-w-[1000px] text-sm">
          <thead>
            <tr className="border-b bg-bg-light text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3">Employee ID</th>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Pay period</th>
              <th className="px-4 py-3 text-right">Regular</th>
              <th className="px-4 py-3 text-right">OT</th>
              <th className="px-4 py-3 text-right">DT</th>
              <th className="px-4 py-3 text-right">Premium</th>
              <th className="px-4 py-3 text-right">Gross pay</th>
              <th className="px-4 py-3 text-right">Equip.</th>
              <th className="px-4 py-3">Notes</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.employeeId} className="border-b border-border/60 last:border-0 hover:bg-bg-light/50">
                <td className="px-4 py-3 font-mono font-medium">{row.employeeId}</td>
                <td className="px-4 py-3">{row.name}</td>
                <td className="px-4 py-3 text-muted-foreground">{row.payPeriodLabel}</td>
                <td className="px-4 py-3 text-right tabular-nums">{formatHours(row.regularHours)}</td>
                <td className="px-4 py-3 text-right tabular-nums">{formatHours(row.overtimeHours)}</td>
                <td className="px-4 py-3 text-right tabular-nums">{formatHours(row.doubleTimeHours)}</td>
                <td className="px-4 py-3 text-right tabular-nums">{formatCurrency(row.premiumPay)}</td>
                <td className="px-4 py-3 text-right tabular-nums font-semibold">
                  {formatCurrency(row.grossPay)}
                </td>
                <td className="px-4 py-3 text-right tabular-nums">{formatCurrency(row.equipmentCost)}</td>
                <td className="px-4 py-3 text-muted-foreground">{row.notes || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-sm text-muted-foreground">
        Export payroll-ready CSV or PDF after period lock. Large sites paginate reports server-side
        — no browser memory limits on 5,000-worker rosters.
      </p>
    </div>
  );
}
